import styled from 'styled-components';

const CashBackStyle = styled.section`
	--distanceTitleButton: var(--sp7x);
	--sizeImage: 27%;
	--borderRadius: var(--sp4x);

	position: relative;

	.info-wrapper {
		width: calc(100% - 2 * var(--contPaddingLR));
		height: 100%;
		position: absolute;
		top: 50%;
		left: var(--contPaddingLR);
		z-index: 2;
		transform: translateY(-50%);
		display: grid;
	}

	.inner-info {
		display: flex;
		justify-content: center;
		height: 100%;
		flex-direction: column;
		gap: var(--distanceTitleButton);

		.link-item {
			position: relative;
		}

		a.link-item::before {
			content: '';
			position: absolute;
			inset: -6px;
			background-color: transparent;
			z-index: -1;
		}
	}

	.image-cont {
		--proportion: var(--sizeImage);
		overflow: hidden;
		border-radius: var(--borderRadius);

		&::before {
			content: '';
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--backgroundColor);
			opacity: 0.25;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleButton: var(--sp4x);
		--sizeImage: 26%;
		--borderRadius: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 24.4%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 27.3%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTitleButton: var(--sp3x);
		--sizeImage: 33.7%;
		--borderRadius: var(--sp2-5x);

		.empty-2 {
			display: none;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceTitleButton: var(--sp2x);
		--sizeImage: 65.9%;
		--borderRadius: var(--sp2x);

		.inner-info {
			margin-left: var(--sp2x);
		}

		.empty-1 {
			display: none;
		}
	}
`;
export default CashBackStyle;
